import { TTypographyLevels } from '@lib/theme/typography.types';

export const TYPO_LEVEL_MAP: Record<TTypographyLevels, string> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'p',
  body2: 'p',
  body3: 'p',
  buttonPrimary: 'span',
  buttonText: 'span',
  overline: 'span',
  captionLarge: 'span',
  captionSmall: 'span',
};
